import axios from 'axios'
import store from '@/store'

const moviesApi = axios.create({
  baseURL: '',
  headers: { Accept: 'application/json' },
})

moviesApi.interceptors.request.use(
  (config) => {
    const token = store.state.auth.accessToken
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type']
    }
    return config
  },
  (error) => Promise.reject(error),
)

moviesApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config
    if (error.response?.status === 401 && originalRequest && !originalRequest._retry) {
      originalRequest._retry = true
      try {
        await store.dispatch('auth/refreshToken')
        return moviesApi(originalRequest)
      } catch (refreshError) {
        store.dispatch('auth/logout')
        return Promise.reject(refreshError)
      }
    }
    return Promise.reject(error)
  },
)

export default {
  getAllPost() {
    return moviesApi.get('/api/movies/post')
  },
  getPostByID(id) {
    return moviesApi.get(`/api/movies/post/${id}`)
  },
  addPost(formData) {
    return moviesApi.post('/api/movies/post/', formData)
  },
  updatePost(id, formData) {
    return moviesApi.patch(`/api/movies/post/${id}`, formData)
  },
  deletePost(id) {
    return moviesApi.delete(`/api/movies/post/${id}`)
  },
  toggleFavorite(id) {
    return moviesApi.patch(`/api/movies/post/${id}/favorite`)
  },
  moveToCollection(id) {
    return moviesApi.patch(`/api/movies/post/${id}/collection`)
  },
  search(search) {
    return moviesApi.get('/api/movies/search', { params: { search } })
  },
}
